import React from "react";
import "./ruko2.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

import Downtownimages from "../../../media/Ruko/Downtown/Downtown";
import Carsonimages from "../../../media/Ruko/Carson/Carson";
import Quantumimages from "../../../media/Ruko/Quantum/Quantum";
import CityHubimages from "../../../media/Ruko/City Hub/City Hub";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faArrowsUpDownLeftRight,
  faBuilding,
  faLayerGroup,
  faMedal,
} from "@fortawesome/free-solid-svg-icons";

import {faShower} from "@fortawesome/free-solid-svg-icons";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";

const ruko1 = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const QuantumWa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Ruko%20Quantum%20https://marketinggadingserpong.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const DowntownWa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Ruko%20Downtown%20Drive%20https://marketinggadingserpong.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const CityHubWa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Ruko%20City%20Hub%20Commercial%20https://marketinggadingserpong.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  const CarsonWa = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285215127964&text=Halo%20Marketing%20Summarecon,%20Saya%C2%A0bisa%20minta%20detail%20Katalog,%20Simulasi%20dan%20Promo%20terbaru%20produk%20Ruko%20Carson%20https://marketinggadingserpong.com/&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };

  return (
    <div id="ruko" className="container">
      <div className="containercard-ruko">
        <div className="card">
          <Slider {...settings}>
            {Downtownimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Downtown Drive</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Ruko 3 Lantai</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faArrowsUpDownLeftRight} />
            <span> 84m²</span>
            <FontAwesomeIcon color="#334442" icon={faBuilding} />
            <span> 101m²</span>
            <FontAwesomeIcon color="#334442" icon={faLayerGroup} />
            <span> 3</span>
            <FontAwesomeIcon color="#334442" icon={faShower} />
            <span> 3</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">18 Juta/Bulan</div>
            </div>
          </div>
          <div className="cluster-button">
            <button onClick={DowntownWa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {Carsonimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Carson</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Ruko 3 Lantai</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faArrowsUpDownLeftRight} />
            <span> 80m²</span>
            <FontAwesomeIcon color="#334442" icon={faBuilding} />
            <span> 186m²</span>
            <FontAwesomeIcon color="#334442" icon={faLayerGroup} />
            <span> 3</span>
            <FontAwesomeIcon color="#334442" icon={faShower} />
            <span> 3</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">20 Juta/Bulan</div>
            </div>
          </div>
          <div className="cluster-button">
            <button onClick={CarsonWa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
        <div className="card">
          <Slider {...settings}>
            {CityHubimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">City Hub Commercial</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Ruko 3 Lantai</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faArrowsUpDownLeftRight} />
            <span> 84m²</span>
            <FontAwesomeIcon color="#334442" icon={faBuilding} />
            <span> 277m²</span>
            <FontAwesomeIcon color="#334442" icon={faLayerGroup} />
            <span> 3</span>
            <FontAwesomeIcon color="#334442" icon={faShower} />
            <span> 3</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">21 Juta/Bulan</div>
            </div>
          </div>
          <div className="cluster-button">
            <button onClick={CityHubWa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>

        <div className="card">
          <Slider {...settings}>
            {Quantumimages.map((image, index) => (
              <img className="imagecard" key={index} src={image} alt={image} />
            ))}
          </Slider>
          <div className="container-rumah">
            <div className="nama-rumah">Quantum Commercial</div>
            <div className="gridmap">
              <FontAwesomeIcon
                className="icon"
                color="#C88C39"
                icon={faMedal}
              />
              <div className="namalokasi">Ruko 4 Lantai</div>
            </div>
          </div>
          <hr />
          <div className="gridspek">
            <FontAwesomeIcon color="#334442" icon={faArrowsUpDownLeftRight} />
            <span>96m²</span>
            <FontAwesomeIcon color="#334442" icon={faBuilding} />
            <span> 309m²</span>
            <FontAwesomeIcon color="#334442" icon={faLayerGroup} />
            <span> 4</span>
            <FontAwesomeIcon color="#334442" icon={faShower} />
            <span> 4</span>
          </div>
          <hr />
          <div className="containercicilan">
            <div className="judulkartu">
              <div className="startfrom">Start From</div>
            </div>
            <div className="cicilansumban">
              <div className="angka">25 Juta/Bulan</div>
            </div>
          </div>
          <div className="cluster-button">
            <button onClick={QuantumWa} className="cluster-whatsapp">
              <FontAwesomeIcon size="lg" icon={faWhatsapp} />
              &nbsp;Whatsapp
            </button>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default ruko1;
